(() => {
  'use strict';

  if (window.__botoxBeeReleasitLegacyV3) return;
  window.__botoxBeeReleasitLegacyV3 = true;

  const PRODUCT_ID = '10187300110632';
  const config = window.BotoxBeeReleasitLegacyConfig || {};
  const images = config.images || {};
  const TIMER_KEY = 'botox_bee_releasit_offer_deadline_v2';
  const TIMER_MS = 10 * 60 * 1000;
  const OFFER_ORDER = [2, 4, 6];
  const OFFER_COPY = {
    2: {
      title: 'RECIBE 2 BOTOX BEE VENOM',
      plaque: 'OFERTA 2×1',
      detail: 'PAGAS 1 Y RECIBES 2',
      image: images.two,
    },
    4: {
      title: 'RECIBE 4 BOTOX BEE VENOM',
      plaque: '20% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $13.980',
      image: images.four,
    },
    6: {
      title: 'RECIBE 6 BOTOX BEE VENOM',
      plaque: '45% DE DESCUENTO ADICIONAL',
      detail: 'AHORRAS $31.455',
      image: images.six,
    },
  };

  const findFirst = (root, selectors) => {
    for (const selector of selectors) {
      const node = root.querySelector(selector);
      if (node) return node;
    }
    return null;
  };

  const onProductPage = () => {
    const path = window.location.pathname.replace(/\/$/, '').toLowerCase();
    if (path !== '/products/botox-bee-venom') return false;
    const productId = document.querySelector('input[name="product_id"]')?.value;
    return !productId || productId === PRODUCT_ID;
  };

  const getDeadline = () => {
    const now = Date.now();
    try {
      const stored = Number(window.sessionStorage.getItem(TIMER_KEY));
      if (Number.isFinite(stored) && stored > now) return stored;
      const deadline = now + TIMER_MS;
      window.sessionStorage.setItem(TIMER_KEY, String(deadline));
      return deadline;
    } catch (_) {
      return now + TIMER_MS;
    }
  };

  const ensureOfferIntro = (root) => {
    const heading = findFirst(root, ['._rsi-custom-text-field', '._rsi-quantity-offers-main-title']);
    if (!heading) return;

    heading.textContent = '1 - Elige cuántos Botox Bee Venom quieres recibir 👇';
    heading.dataset.bbvOfferHeading = 'true';

    let timer = root.querySelector('.bbv-releasit-offer-timer');
    if (!timer) {
      timer = document.createElement('div');
      timer.className = 'bbv-releasit-offer-timer';
      timer.setAttribute('role', 'timer');
      timer.setAttribute('aria-live', 'off');
      timer.innerHTML = '<span aria-hidden="true">⏰</span><span>La oferta finaliza en <strong>10:00</strong> minutos</span>';
      timer.dataset.deadline = String(getDeadline());
    }

    let assurance = root.querySelector('.bbv-releasit-assurance');
    if (!assurance) {
      assurance = document.createElement('div');
      assurance.className = 'bbv-releasit-assurance';
      assurance.innerHTML = '<span aria-hidden="true">✓</span><span><strong>Envío incluido</strong> · Paga al recibir</span>';
    }

    let basePrice = root.querySelector('.bbv-releasit-base-price');
    if (!basePrice && config.basePriceText) {
      basePrice = document.createElement('div');
      basePrice.className = 'bbv-releasit-base-price';
      const badge = document.createElement('span');
      badge.textContent = '2×1';
      const label = document.createElement('span');
      label.append('Oferta base: ');
      const strong = document.createElement('strong');
      strong.textContent = config.basePriceText;
      label.append(strong);
      basePrice.append(badge, label);
    }

    const ordered = [timer, assurance, basePrice].filter(Boolean);
    heading.after(...ordered);
  };

  const updateTimer = (root) => {
    const timer = root.querySelector('.bbv-releasit-offer-timer');
    const output = timer?.querySelector('strong');
    if (!timer || !output) return;
    const deadline = Number(timer.dataset.deadline || getDeadline());
    const remaining = Math.max(0, deadline - Date.now());
    const minutes = Math.floor(remaining / 60000);
    const seconds = Math.floor((remaining % 60000) / 1000);
    output.textContent = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const offerQuantity = (offer, root) => {
    const offers = [...root.querySelectorAll('._rsi-quantity-offers-offer')];
    const position = offers.indexOf(offer);
    return OFFER_ORDER[position] || null;
  };

  const enhanceOffer = (offer, root) => {
    const quantity = offerQuantity(offer, root);
    const copy = OFFER_COPY[quantity];
    if (!copy) return;

    const title = findFirst(offer, ['._rsi-quantity-offers-title', '[class*="quantity-offers-title"]']);
    if (title) {
      title.textContent = copy.title;
      title.dataset.bbvOfferCopy = 'true';
    }

    const plaque = findFirst(offer, ['._rsi-quantity-offers-plaque', '[class*="quantity-offers-plaque"]']);
    if (plaque) {
      plaque.textContent = copy.plaque;
      plaque.dataset.bbvOfferCopy = 'true';
    }

    const info = findFirst(offer, ['._rsi-quantity-offers-info', '[class*="quantity-offers-info"]']);
    if (info) {
      let detail = info.querySelector('.bbv-releasit-offer-detail');
      if (!detail) {
        detail = document.createElement('div');
        detail.className = 'bbv-releasit-offer-detail';
        info.append(detail);
      }
      detail.textContent = copy.detail;
    }

    const image = findFirst(offer, ['img._rsi-modal-line-item-image', 'img[class*="modal-line-item-image"]']);
    if (image && copy.image) {
      image.src = copy.image;
      image.removeAttribute('srcset');
      image.alt = `Recibes ${quantity} Botox Bee Venom`;
      image.loading = 'lazy';
      image.decoding = 'async';
    }
  };

  const enhance = () => {
    if (!onProductPage()) return;
    const root = document.querySelector('#_rsi-cod-form-modal');
    if (!root) return;
    root.dataset.bbvEnhanced = 'true';
    ensureOfferIntro(root);
    root.querySelectorAll('._rsi-quantity-offers-offer').forEach((offer) => enhanceOffer(offer, root));
    updateTimer(root);
  };

  let queued = false;
  const queueEnhance = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      enhance();
    });
  };

  const observer = new MutationObserver(queueEnhance);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('change', queueEnhance, true);
  document.addEventListener('click', queueEnhance, true);
  document.addEventListener('DOMContentLoaded', queueEnhance, { once: true });
  window.setInterval(() => {
    const root = document.querySelector('#_rsi-cod-form-modal[data-bbv-enhanced="true"]');
    if (root) updateTimer(root);
  }, 1000);
  window.addEventListener('load', () => {
    window.setTimeout(() => {
      if (typeof window.loadAsync === 'function') window.loadAsync();
      queueEnhance();
    }, 500);
  }, { once: true });
  queueEnhance();
})();
